/* generated from backend OpenAPI -- do not edit */
import type { JSONSchema } from 'zod/v4/core';
export const schema = {
  "type": "object",
  "properties": {
    "type": {
      "type": "string",
      "enum": [
        "ack"
      ]
    },
    "payload": {
      "type": "object",
      "properties": {
        "action": {
          "type": "string",
          "enum": [
            "subscribe"
          ]
        },
        "authorizationGeneration": {
          "type": "number",
          "enum": [
            1
          ]
        },
        "count": {
          "type": "integer",
          "minimum": 0,
          "maximum": 9007199254740991
        },
        "requestedTopics": {
          "type": "array",
          "items": {
            "type": "string",
            "pattern": "^communications\\.(funnel|conversation)\\.[1-9]\\d*$",
            "description": "Communications realtime topic"
          }
        },
        "topics": {
          "type": "array",
          "items": {
            "type": "string",
            "pattern": "^communications\\.(funnel|conversation)\\.[1-9]\\d*$",
            "description": "Communications realtime topic"
          }
        }
      },
      "required": [
        "action",
        "authorizationGeneration",
        "count",
        "requestedTopics",
        "topics"
      ]
    }
  },
  "required": [
    "type",
    "payload"
  ],
  "x-browser-runtime-schema": true
} satisfies JSONSchema.JSONSchema;
